<template>
    <base-button
        :is-disabled="isDisabled"
        :class="appliedVariant"
        class="rounded-full"
    >
        <slot />
    </base-button>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            variant: {
                type: String,
                default: 'primary',
            },

            isDisabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                variants: {
                    primary: 'bg-red text-white text-[16px] h-[42px]',
                    primaryDisabled: 'bg-red text-white bg-opacity-60 cursor-not-allowed text-[16px] h-[42px]',
                    secondary: 'border-2 border-black bg-white text-[14px]',
                    tertiary: 'bg-black text-white text-[14px]',
                },
            };
        },

        computed: {
            appliedVariant() {
                return this.variant === 'primary' && this.isDisabled === true ? this.variants.primaryDisabled : this.variants[this.variant];
            },
        },
    };
</script>
